import { combineReducers } from "redux";
import MutualFundsQuoteOverviewReducer from "./reducer/MutualFundsOverview";
export default combineReducers({ MutualFundsQuoteOverviewReducer: MutualFundsQuoteOverviewReducer });
